


















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class gtContentBlock extends Vue {
  @Prop({ type: String }) title;
}
